/** 에디터 본문 UI 등록 — 종류 레지스트리(app)가 features 를 import 하지 않도록 features 쪽에서 선언한다(P5). 부트스트랩이 import */
import { registerParticipantUi } from '@/app/participants/participantUi';

registerParticipantUi('mars', { editorBody: () => import('./MarsEditorBody') });
registerParticipantUi('fmu', { editorBody: () => import('./ModelicaEditorBody') });
